import React from 'react';
import { Box, Button } from '@mui/material';
import { styled } from '@mui/system';
import GridViewIcon from '@mui/icons-material/GridView';
import MapIcon from '@mui/icons-material/Map';

const ToggleContainer = styled(Box)({
    position: 'fixed',
    left: '50%',
    transform: 'translateX(-50%)',
    bottom: '100px',
    zIndex: 1000,
    display: 'flex',
    justifyContent: 'center',
    width: 'auto'
});

const StyledButton = styled(Button)(({ theme }) => ({
    backgroundColor: '#fff',
    border: '1px solid #ddd',
    borderRadius: '30px',
    padding: '8px 16px',
    textTransform: 'none',
    fontSize: '14px',
    fontWeight: 500,
    color: '#222',
    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
    '&:hover': {
        backgroundColor: '#f7f7f7',
        boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
    },
    '& .MuiButton-startIcon': {
        marginRight: '4px',
    }
}));

const ViewToggle = ({ view, onViewChange }) => {
    const handleClick = () => {
        const newView = view === 'grid' ? 'map' : 'grid';
        onViewChange(newView);
    };

    return (
        <ToggleContainer>
            <StyledButton
                onClick={handleClick}
                startIcon={view === 'grid' ? <MapIcon /> : <GridViewIcon />}
            >
                {view === 'grid' ? 'Map' : 'List'}
            </StyledButton>
        </ToggleContainer>
    );
};

export default ViewToggle;